import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(`notice`),
  style: {"z-index":"1002"}
}
const _hoisted_2 = { class: "message" }
const _hoisted_3 = { class: "fr" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.Notice.message)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.Notice.message) + " ", 1),
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/popUp/close_white.png`),
              width: "24",
              height: "24",
              class: "pointer",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
            }, null, 8, _hoisted_4)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}